<template>
  <p
    :class="[
      $style.base,
      $style[type]
    ]"
    v-bind="$attrs"
  >
    <slot />
  </p>
</template>

<script setup lang="ts">

interface DisplayTextProps {
  type?: 'bold' | 'small'
  color?: 'turquoise' | 'lightturquoise' | 'white'
  inline?: boolean
}

const { type, color } = defineProps<DisplayTextProps>()

const colorVar = computed(() => `var(--color-${color})`)
</script>
<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<style module>
.base {
  font-size: clamp(16px, 2vw, 18px);
  line-height: clamp(19px, 2vw, 21px);
  letter-spacing: 0.0085em;
  margin: 0;
  max-width: 80ch;
  color: v-bind(colorVar);

  *+& {
    margin-top: var(--space-xxs);
  }
}

.bold {
  font-size: 18px;
  font-weight: 600;
}

.small {
  font-size: 14px;
}

</style>
